export const isEmptyObject = (obj: object | undefined): boolean => {
  return Object.keys(obj || {}).length === 0;
};
